import Vue from "vue";
import Router from "vue-router";
// import AppHeader from "./layout/AppHeader";
// import AppFooter from "./layout/AppFooter";
import Components from "./views/Components.vue";
import Terminos from "./views/Terminos.vue";
import Aviso from "./views/Aviso.vue";
import Legales from "./views/Legales.vue";
import Bases from "./views/Bases.vue";
import Ganadores from "./views/Ganadores.vue";
import Contacto from "./views/Contacto.vue";

Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "components",
      components: {
        // header: AppHeader,
        default: Components,
        // footer: AppFooter
      }
    },
    {
      path: "/terminos-y-condiciones",
      name: "terminos",
      components: {
        default: Terminos,
      }
    },
    {
      path: "/aviso-de-privacidad",
      name: "privacidad",
      components: {
        default: Aviso,
      }
    },
    {
      path: "/legales",
      name: "legales",
      components: {
        default: Legales,
      }
    },
    {
      path: "/bases",
      name: "bases",
      components: {
        default: Bases,
      }
    },
    {
      path: "/ganadores",
      name: "ganadores",
      components: {
        default: Ganadores,
      }
    },
    {
      path: "/contacto",
      name: "contacto",
      components: {
        default: Contacto,
      }
    },
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
